module.exports = __webpack_public_path__ + "img/bild7.96e52f3b.jpeg";